import styles from './stepperHorizontal.module.css';

export const stepperHorizontalDataOne = [
  {
    step: '1',
    title: 'EVENT DETAILS',
  },
  {
    step: '2',
    title: 'BOOKING DETAILS',
  },
  {
    step: '3',
    title: 'REGISTRATION DETAILS',
  },
];

export const stepperHorizontalDataTwo = [
  {
    step: '1',
    title: 'EVENT DETAILS',
  },
  {
    step: '2',
    title: 'REGISTRATION DETAILS',
  },
];

const StepperHorizontal = ({ level, audienceFlow }) => {
  let stepData = []
  if(audienceFlow){
    stepData = stepperHorizontalDataOne
  }else{
    stepData = stepperHorizontalDataTwo
  }
  return (
    <div>
    <div className={styles.stepperHorizontal}>
      {stepData.map((data, index) => (
        <div
          key={index}
          className={`${styles.step} ${
            level === index + 1 ? styles.active : level > index + 1 ? styles.done : ''
          }`}
        >
          <div className={styles.stepCircleTextContainer}>
            <div className={styles.stepCircle}>
              <span>{index + 1}</span>
            </div>
            <div
              className={`${styles.stepTitle} ${
                level === index + 1 ? styles.active : ''
              }`}
            >
              {data.title}
            </div>
          </div>

          <div className={styles.stepBarLeft} />
          <div className={styles.stepBarRight} />
        </div>
      ))}
    </div>
    </div>

  );
};

export default StepperHorizontal;
